import { useCallback, useState } from 'react';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { sharedColors } from '../../utils/Style';

type SearchBoxProps = {
  label?: string;
  placeholder?: string;
  initialValue: string;
  onChange: (value: string) => void;
  width?: string | number;
};

export const SearchBox = ({
  label,
  placeholder,
  initialValue,
  onChange,
  width = 300,
}: SearchBoxProps) => {
  const [value, setValue] = useState(initialValue);

  const handleKeyDown = useCallback(
    (e: any) => {
      if (e.keyCode === 13) {
        onChange(value);
      }
    },
    [onChange, value],
  );

  return (
    <TextField
      size='small'
      label={label}
      placeholder={placeholder}
      value={value}
      sx={{ width, backgroundColor: sharedColors.white, height: 'fit-content' }}
      onChange={(e) => setValue(e.target.value)}
      onKeyDown={handleKeyDown}
      InputProps={{
        endAdornment: (
          <InputAdornment position='end'>
            <IconButton
              onClick={() => onChange(value)}
              sx={{ p: 0, minHeight: 0, minWidth: 0 }}
            >
              <SearchIcon />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};
